import { plainToClass } from "class-transformer";
import { CombineDisplayOption, JsonItem, AppUserExtended, PickListItem, AppUserRedacted, AppUserAffiliation, RevamppCore, RevamppProject, AppUserGroupCommittee } from "../../list-management/scripts/list-management.objects";
import { TableColumnVisibilityControllerV2, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { DoArraysOverlap } from "../../../shared/scripts/array-functions";
import { IFilter, InitializeFilterDropdown } from "../../../shared/scripts/dropdown-functions";
import { UserExperience, UserExperienceEntry } from "../../../auth/pages/profile/scripts/expertise.objects";
import { ExpertiseArea } from "../../../auth/pages/profile/scripts/expertise.dictionary";
import _ from "lodash";

export class UserDirectoryPage implements IFilter {

    users: AppUserExtended[];
    pickLists: JsonItem[];
    dataTable: any;
    tableColumnController: TableColumnVisibilityControllerV2;
    visibleUserEmails: string;
    expertiseSidebar: HTMLElement;
    sideBarRemoved: boolean; 
    affiliationDropdownIds: string[];
    groupDropdownIds: string[];
    expertiseDropdownIds: string[];

    expertiseAreas: ExpertiseArea[];

    rolePickList: PickListItem[];
    centerPickList: PickListItem[];
    corePickList: PickListItem[];
    projectPickList: PickListItem[];
    groupPickList: PickListItem[];
    groupRolePickList: PickListItem[];
    degreePickList: PickListItem[];
    organizationPickList: PickListItem[];

    constructor(userJson: any, userExpertiseJson: any, pickListJson: any) {
        $(() => {
            this.users = plainToClass(AppUserExtended, <AppUserExtended[]>userJson);
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickListJson);

            let expertiseList: UserExperienceEntry[] = plainToClass(UserExperienceEntry, <UserExperienceEntry[]>userExpertiseJson);
            expertiseList.map((entry: UserExperienceEntry) => {
                let user: AppUserExtended = this.users.find((user: AppUserExtended) => user.AppUser.Email == entry.Email);
                if (user != undefined) {
                    user.AppUser.Expertise = plainToClass(UserExperience, <UserExperience>JSON.parse(entry.ExperienceJson));
                }
            });

            this.rolePickList = this.pickLists.find(list => list.Id == "pl-member-roles").Json;
            this.centerPickList = this.pickLists.find(list => list.Id == "pl-center").Json;

            let allCores: RevamppCore[] = this.pickLists.find(list => list.Id == "all-cores").Json;
            this.corePickList = [];
            allCores.forEach(core => {
                let newPickListItem = new PickListItem();
                newPickListItem.Id = core.Id;
                let centerName = "";
                let foundCenter = this.centerPickList.find(center => center.Id == core.CenterId);
                if (foundCenter) {
                    centerName = `${foundCenter.Value} - `;
                }
                newPickListItem.Value = `${centerName}${core.CoreName}`;
                this.corePickList.push(newPickListItem);
            })

            let allProjects: RevamppProject[] = this.pickLists.find(list => list.Id == "all-projects").Json;
            this.projectPickList = [];
            allProjects.forEach(project => {
                let newPickListItem = new PickListItem();
                newPickListItem.Id = project.Id;
                let centerName = "";
                let foundCenter = this.centerPickList.find(center => center.Id == project.CenterId);
                if (foundCenter) {
                    centerName = `${foundCenter.Value} - `;
                }
                newPickListItem.Value = `${centerName}${project.ProjectName}`;
                this.projectPickList.push(newPickListItem);
            });

            this.groupPickList = this.pickLists.find(list => list.Id == "pl-groups").Json;
            this.groupRolePickList = this.pickLists.find(list => list.Id == "pl-group-roles").Json;

            this.degreePickList = this.pickLists.find(list => list.Id == "pl-degrees").Json;
            this.organizationPickList = this.pickLists.find(list => list.Id == "pl-organization-names").Json;

            this.initializeFilters();
            this.initializeExpandableContentWatcher();

            this.initializeTable();

            //triggers the redraw to account due to column with icon. will see a slight "popping" if looking carefully            
            setTimeout(() => {
                $("#user-directory-table").DataTable().columns.adjust().draw();
            }, 1);

            this.dataTable.on('draw', () => { this.setOtherTooltipSize() });
            this.expertiseSidebar = document.getElementById('expertise-sidebar');
            this.sideBarRemoved = false;
        });
    }

    initializeFilters(): void {

        let roleOptions: string[][] = this.rolePickList.map(item => {
            return [item.Id.toString(), item.Value]
        })
        InitializeFilterDropdown('#revampp-role-dropdown', [], this, roleOptions, false);

        let centerOptions: string[][] = this.centerPickList.map(item => {
            return [item.Id.toString(), item.Value]
        });
        InitializeFilterDropdown('#center-dropdown', [], this, centerOptions, false);

        let coreOptions: string[][] = this.corePickList.map(item => {
            return [item.Id.toString(), item.Value]
        });
        InitializeFilterDropdown('#core-dropdown', [], this, coreOptions, false);

        let projectOptions: string[][] = this.projectPickList.map(item => {
            return [item.Id.toString(), item.Value]
        });
        InitializeFilterDropdown('#project-dropdown', [], this, projectOptions, false);

        let organizationOptionIds: string[] = [];
        let orgOptions: string[][] = [];
        let groupOptions: string[][] = [];
        let groupOptionNames: string[] = [];
        let groupOptionsVals: string[] = [];
        this.users.forEach(user => {
            let userOrgIds = user.AppUser.OrganizationIds;
            let userOrgIdArr = [];
            if (userOrgIds) {
                userOrgIdArr = userOrgIds.split("|");
                organizationOptionIds.push(...userOrgIdArr);
            }

            let currentGroups = user.AppUserGroupList;
            currentGroups.forEach(group => {
                let foundGroup = this.groupPickList.find(item => item.Id == group.GroupId);
                let foundRole = this.groupRolePickList.find(item => item.Id == group.GroupRoleId);
                if (foundGroup && foundRole) {
                    let optionName = `${foundGroup.Value} (${foundRole.Value})`;
                    if (!groupOptionNames.includes(optionName)) {
                        groupOptionNames.push(optionName);
                        let optionVal = `${group.GroupId.toString()}|${group.GroupRoleId.toString()}`;
                        groupOptionsVals.push(optionVal);
                    }
                }
            })
        });

        organizationOptionIds = _.uniq(organizationOptionIds);
        organizationOptionIds.forEach(orgId => {
            let foundItem = this.organizationPickList.find(org => org.Id.toString() == orgId);
            if (foundItem) {
                orgOptions.push([foundItem.Id.toString(), foundItem.Value]);
            }
        });
        InitializeFilterDropdown("#organization-dropdown", [], this, orgOptions, false);

        this.affiliationDropdownIds = ['#revampp-role-dropdown', '#center-dropdown', '#core-dropdown', '#project-dropdown', '#organization-dropdown'];

        for (let i = 0; i < groupOptionNames.length; i++) {
            groupOptions.push([groupOptionsVals[i], groupOptionNames[i]]);
        }
        InitializeFilterDropdown("#revampp-group-dropdown", [], this, groupOptions, false);

        this.groupDropdownIds = ["#revampp-group-dropdown"]


        let expertiseAreas: ExpertiseArea[] = ExpertiseArea.GetExpertiseAreas();
        InitializeFilterDropdown('#research-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "research").map(exp => [exp.id, exp.value]), false);
        InitializeFilterDropdown('#virus-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "virus").map(exp => [exp.id, exp.value]), false);
        InitializeFilterDropdown('#vaccine-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "vaccine").map(exp => [exp.id, exp.value]), false);
        InitializeFilterDropdown('#antibody-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "antibody").map(exp => [exp.id, exp.value]), false);
        InitializeFilterDropdown('#animalmodel-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "animalmodel").map(exp => [exp.id, exp.value]), false);
        InitializeFilterDropdown('#management-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "management").map(exp => [exp.id, exp.value]), false);
        InitializeFilterDropdown('#quality-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "quality").map(exp => [exp.id, exp.value]), false);
        InitializeFilterDropdown('#humantrial-dropdown', undefined, this, expertiseAreas.filter((area: ExpertiseArea) => area.category == "humantrial").map(exp => [exp.id, exp.value]), false);

        this.expertiseDropdownIds = ['#research-dropdown', '#virus-dropdown', '#vaccine-dropdown', '#antibody-dropdown', '#animalmodel-dropdown', '#management-dropdown', '#quality-dropdown', '#humantrial-dropdown'];
        this.expertiseAreas = expertiseAreas;
    }

    //makes sure dropdown are init so they open downwards
    initializeExpandableContentWatcher(): void {
        let page = this;
        $('.expandable-content').each(function () {
            $(this).on('shown.bs.collapse', (e) => {
                if (e.currentTarget.id == "affiliations") {
                    page.affiliationDropdownIds.forEach((id: string) => $(id).selectpicker("refresh"));
                }
                if (e.currentTarget.id == "groups") {
                    page.groupDropdownIds.forEach((id: string) => $(id).selectpicker("refresh"));
                }
                else if (e.currentTarget.id == "expertise") {
                    page.expertiseDropdownIds.forEach((id: string) => $(id).selectpicker("refresh"));
                }
            });
        });
    }

    getDisplayName(user: AppUserRedacted): string {    
        let userMenu = `
        <div class="btn-group dropright">
            <button type="button" class="dropdown-toggle user-name-select" data-toggle="dropdown" data-id="${user.Id}" aria-haspopup="true" aria-expanded="false" onclick="page.updateMenuPosition(event)">
                <span class="underline">${user.FirstName} ${user.LastName}</span>
            </button>
            <div class="dropdown-menu revampp-dropdown-menu ml-2">

            </div>
        </div>
        `

        return userMenu;
    }

    getDisplayAffiliations(affiliations: AppUserAffiliation[]): string {
        let affiliationRoleList: string[] = affiliations.map(affiliation => {
            let roleId = affiliation.RoleId;
            let foundRole = this.rolePickList.find(role => role.Id == roleId);
            if (foundRole) {
                return foundRole.Value;
            }
            else {
                return "";
            }
        }).filter(roleName => roleName != "");
        affiliationRoleList = _.uniq(affiliationRoleList);
        affiliationRoleList.sort();

        return affiliationRoleList.join(",<br/>");
    }

    getDisplayCenters(affiliations: AppUserAffiliation[]): string {
        let affiliationCenterList: string[] = affiliations.map(affiliation => {
            let centerId = affiliation.CenterId;
            let foundCenter = this.centerPickList.find(center => center.Id == centerId);
            if (foundCenter) {
                return foundCenter.Value;
            }
            else {
                return "";
            }
        }).filter(centerName => centerName != "");
        affiliationCenterList = _.uniq(affiliationCenterList);
        affiliationCenterList.sort();

        return affiliationCenterList.join(", ");
    }

    getDisplayCores(affiliations: AppUserAffiliation[]): string {
        let affiliationCoreList: string[] = affiliations.map(affiliation => {
            let coreId = affiliation.CoreId;
            let foundCore = this.corePickList.find(core => core.Id == coreId);
            if (foundCore) {
                return foundCore.Value;
            }
            else {
                return "";
            }
        }).filter(coreName => coreName != "");
        affiliationCoreList = _.uniq(affiliationCoreList);
        affiliationCoreList.sort();

        return affiliationCoreList.join(",<br/>"); 
    }

    getDisplayProjects(affiliations: AppUserAffiliation[]): string {
        let affiliationProjectList: string[] = affiliations.map(affiliation => {
            let projectId = affiliation.ProjectId;
            let foundProject = this.projectPickList.find(project => project.Id == projectId);
            if (foundProject) {
                return foundProject.Value;
            }
            else {
                return "";
            }
        }).filter(projectName => projectName != "");
        affiliationProjectList = _.uniq(affiliationProjectList);
        affiliationProjectList.sort();

        return affiliationProjectList.join(",<br/>");
    }

    getExpertiseDisplay(userExpertise: UserExperience, experienceName: string): string {
        if (!userExpertise) {
            return "";
        }
        let foundExpertiseIds: string[] = userExpertise[experienceName];
        if (!foundExpertiseIds) {
            foundExpertiseIds = [];
        }
        let foundExpertise: string[] = [];
        foundExpertiseIds.forEach(expId => {
            let foundArea = this.expertiseAreas.find(exp => exp.id == expId);
            if (foundArea) {
                foundExpertise.push(foundArea.value);
            }
        })
        foundExpertise.sort();
        return foundExpertise.join(',<br/>');
    }

    getGroupsDisplay(groups: AppUserGroupCommittee[]): string {
        let groupsList: string[] = groups.map(group => {
            let groupId = group.GroupId
            let foundGroup = this.groupPickList.find(item => item.Id == groupId);
            let foundRole = this.groupRolePickList.find(item => item.Id == group.GroupRoleId);

            if (foundGroup && foundRole) {
                return `${foundGroup.Value} (${foundRole.Value})`;
            }
            else {
                return "";
            }
        }).filter(groupName => groupName != "");
        groupsList = _.uniq(groupsList);
        groupsList.sort();

        return groupsList.join(",<br/>");
    }

    getDegreesDisplay(terminalDegreeIdString: string) {
        let returnedDisplay = "";
        if (!terminalDegreeIdString) {
            return returnedDisplay;
        }

        let degreeIdArr = terminalDegreeIdString.split("|");
        let degreeStrArr: string[] = [];
        degreeIdArr.forEach(id => {
            let foundItem = this.degreePickList.find(item => item.Id.toString() == id);
            if (foundItem) {
                degreeStrArr.push(foundItem.Value);
            }
        });

        degreeStrArr.sort();
        returnedDisplay = degreeStrArr.join(", ");
        return returnedDisplay;
    }

    getOrgDisplay(orgIdString: string) {
        let returnedDisplay = "";
        if (!orgIdString) {
            return returnedDisplay;
        }

        let orgIdArr = orgIdString.split("|");
        let orgStrArr: string[] = [];
        orgIdArr.forEach(id => {
            let foundItem = this.organizationPickList.find(item => item.Id.toString() == id);
            if (foundItem) {
                orgStrArr.push(foundItem.Value);
            }
        });

        orgStrArr.sort();
        returnedDisplay = orgStrArr.join(",<br/>");
        return returnedDisplay;
    }

    getCombinedContent(data: any[], combineDisplayOptions: CombineDisplayOption[]) {
        let returnContent = "";
        if (data.length == 0) {
            return returnContent;
        }

        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDisplay = "";
            for (let j = 0; j < combineDisplayOptions.length; j++) {
                let options = combineDisplayOptions[j];
                let prop = _.get(item, options.propName);
                if (prop) {
                    let pickList: PickListItem[] = this.pickLists.find(list => list.Id == options.pickListName)?.Json;
                    if (pickList) {
                        let foundVal: PickListItem = pickList.find(target => target.Id.toString() == prop.toString());
                        if (foundVal) {
                            itemDisplay += `${options.prevContent}${foundVal.Value}${options.endContent}`;
                        }
                    }
                }
            }
            returnContent += itemDisplay;

            if (i < (data.length - 1)) {
                returnContent += "<hr class='my-1'>"
            }
        }

        return returnContent;
    }


    initializeTable(): void {
        let affiliationOptions: CombineDisplayOption[] = [
            new CombineDisplayOption("RoleId", "pl-member-roles", "<br>"),
            new CombineDisplayOption("CenterId", "pl-center", ""),
            new CombineDisplayOption("CoreId", "pl-core", "", " - "),
            new CombineDisplayOption("ProjectId", "pl-project", "", " - ")
        ];

        let groupOptions: CombineDisplayOption[] = [
            new CombineDisplayOption("GroupRoleId", "pl-group-roles", " - "),
            new CombineDisplayOption("GroupId", "pl-groups", "")
        ]

        let page = this;
        this.dataTable = $('#user-directory-table').DataTable({
            "dom": '<"collapse-filters"><"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            order: [[0, "asc"]],
            columns: [
                {
                    data: function (row, type, val, meta) {
                        if (type === "sort") {
                            return row.AppUser.LastName;
                        }
                        else if (type === "display" || type === "filter") {
                            return page.getDisplayName(row.AppUser);
                        }
                        return row.AppUser
                    },
                    title: "Name",
                    className: "text-left font-size12 nowrap"
                },
                { data: "AppUser.Email", title: "Email", className: "text-left font-size12 nowrap", visible: false },
                { data: "AppUserAffiliationList", title: "ReVAMPP Affiliation(s)", className: "affiliations text-left font-size12 lh-normal nowrap", render: (data, type) => { return this.getCombinedContent(data, affiliationOptions)} },
                //{ data: "AppUserAffiliationList", title: "Center(s)", className: "affiliations text-left font-size12 table-column-sm", render: (data, type) => { return this.getDisplayCenters(data) } },
                //{ data: "AppUserAffiliationList", title: "Core(s)", className: "affiliations text-left font-size12 table-column-lg", render: (data, type) => { return this.getDisplayCores(data) } },
                //{ data: "AppUserAffiliationList", title: "Project(s)", className: "affiliations text-left font-size12 table-column-lg", render: (data, type) => { return this.getDisplayProjects(data) } },
                { data: "AppUser.OrganizationIds", title: "Organization/Institution", className: "affiliations text-left font-size12 table-column-md", render: (data) => { return this.getOrgDisplay(data) } },
                { data: "AppUserGroupList", title: "Groups/Committees", className: "groups text-left font-size12 lh-normal nowrap", render: (data, type) => { return this.getCombinedContent(data, groupOptions) } },
                { data: "AppUser.TerminalDegreeIds", title: "Degree(s)", className: "expertise text-left font-size12 nowrap", render: (data, type) => { return this.getDegreesDisplay(data)} },
                { data: "AppUser.Expertise", title: "Research/Technical Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "ResearchAreas") } },
                { data: "AppUser.Expertise", title: "Virus Family Research Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "VirusFamilies") } },
                { data: "AppUser.Expertise", title: "Vaccine Platform Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "VaccinePlatforms") } },
                { data: "AppUser.Expertise", title: "Antibody Platform Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "AntibodyPlatforms") } },
                { data: "AppUser.Expertise", title: "Animal Model Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "AnimalModels") } },
                { data: "AppUser.Expertise", title: "Administrative/Project Management Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "ProjectManagement") } },
                { data: "AppUser.Expertise", title: "Quality/Regulatory Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "QualityRegulatory") } },
                { data: "AppUser.Expertise", title: "Human Study/Trial Expertise", className: "expertise text-left font-size12 table-column-md", render: (data, type) => { return this.getExpertiseDisplay(data, "HumanStudies") } },
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                },
                {
                    text: '<i class="fas fa-envelope"></i>',
                    titleAttr: 'Send Email',
                    action: (e, dt, node, config) => {

                        navigator.clipboard.writeText(this.visibleUserEmails).then(
                            () => {
                                $('#directory-email-modal').modal('show');
                                $('#modal-email-list').text(this.visibleUserEmails);
                            });
                    }
                }
            ],
            data: this.users,
            initComplete: (settings, json) => {}
        });

        $(".top-controls").addClass('row mx-0');

        $(".column-select").addClass('col-12 col-md-4 px-0');
        $(".column-select").empty().html('<div id="column-select" class="truncated-select"></div>');
        $(".collapse-filters").empty().html('<button type="button" class="btn btn-sm btn-outline-secondary font-size11 collapse-button" id="collapse-button" onclick="page.toggleExpertiseSidebar()">Hide Filters</button>');

        $(".search-bar").addClass('col-12 col-md-3 align-self-end px-md-3 px-0');

        $(".count-found").addClass('col-12 col-md-5 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0 pl-md-3 pl-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"people-found-count\"></span></div>');
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityControllerV2('#user-directory-table', '#column-select', [
            new TableColumnGroup("Affiliations", true, [], "affiliations"),
            new TableColumnGroup("Groups/Committees", false, [], "groups"),
            new TableColumnGroup("Expertise", false, [], "expertise"),
        ], "directory-column-select");

        $('#user-directory-table').on('search.dt', (e, settings) => {
            this.createEmailList(this.dataTable.rows({ search: 'applied' }).data());
            this.setPeopleFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });

        $(`#user-directory-table tbody`).on('click', 'td', (event) => {
            $("#detail-menu-container").find(".revampp-dropdown-menu").removeClass("show");
        });

        this.createEmailList(this.users);
        this.setPeopleFoundLabel(this.users.length);
    }

    updateTable(matchingUsers: AppUserExtended[]): void {

        this.dataTable.clear();
        this.dataTable.rows.add(matchingUsers).draw();
        this.setPeopleFoundLabel(matchingUsers.length);
        this.createEmailList(matchingUsers);
    }

    triggerFilter(): void {
        let filteredUsers = _.cloneDeep(this.users);

        // Affiliations
        filteredUsers = filteredUsers.filter(userExtended => this.getAffiliationMatch(userExtended, "RoleId", "#revampp-role-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getAffiliationMatch(userExtended, "CenterId", "#center-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getAffiliationMatch(userExtended, "CoreId", "#core-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getAffiliationMatch(userExtended, "ProjectId", "#project-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getPropMatch(userExtended, "AppUser.OrganizationIds", "#organization-dropdown"));

        // Groups
        filteredUsers = filteredUsers.filter(userExtended => this.getGroupMatch(userExtended, "#revampp-group-dropdown"));

        //Expertise
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "ResearchAreas", "#research-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "VirusFamilies", "#virus-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "VaccinePlatforms", "#vaccine-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "AntibodyPlatforms", "#antibody-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "AnimalModels", "#animalmodel-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "ProjectManagement", "#management-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "QualityRegulatory", "#quality-dropdown"));
        filteredUsers = filteredUsers.filter(userExtended => this.getExpertiseMatch(userExtended, "HumanStudies", "#humantrial-dropdown"));

        this.updateTable(filteredUsers);
    }

    getExpertiseMatch(userExtended: AppUserExtended, expCategory: string, dropdownId: string): boolean {
        let selectedExpertise: string[] = <string[]>$(dropdownId).val();

        // check if nothing selected
        if (selectedExpertise.length == 0) {
            return true;
        }
        let userExpertise = userExtended.AppUser.Expertise;
        if (!userExpertise) {
            return false;
        }

        let targetExpertise = userExpertise[expCategory];
        if (!targetExpertise) {
            return false;
        }

        return DoArraysOverlap(targetExpertise, selectedExpertise);
    }

    getAffiliationMatch(userExtended: AppUserExtended, propName: string, dropdownId: string): boolean {
        let selectedAffiliation: string[] = <string[]>$(dropdownId).val();

        // check if nothing selected
        if (selectedAffiliation.length == 0) {
            return true;
        }

        let userAffiliations: string[] = userExtended.AppUserAffiliationList.map(affiliation => _.get(affiliation, propName)?.toString());
        userAffiliations = userAffiliations.filter(item => item != null && item != undefined);
        return DoArraysOverlap(userAffiliations, selectedAffiliation);
    }

    getGroupMatch(userExtended: AppUserExtended, dropdownId: string): boolean {
        let selectedGroup: string[] = <string[]>$(dropdownId).val();

        // check if nothing selected
        if (selectedGroup.length == 0) {
            return true;
        }

        let userGroups: string[] = userExtended.AppUserGroupList.map(group => {
            return `${group.GroupId.toString()}|${group.GroupRoleId.toString()}`;
        });

        userGroups = userGroups.filter(item => item != null && item != undefined);
        return DoArraysOverlap(userGroups, selectedGroup);
    }

    getPropMatch(userExtended: AppUserExtended, propName: string, dropdownId: string): boolean {
        let selectedValues: string[] = <string[]>$(dropdownId).val();
        if (selectedValues.length == 0) {
            return true;
        }

        let property: string = _.get(userExtended, propName);
        let propArr = [];
        if (property) {
            propArr = property.split("|");
        }
        return DoArraysOverlap(propArr, selectedValues);      
    }

    getSelectedDropdownValues(selectId: string): any {
        //return $(selectId).selectpicker('val');
        return $(selectId).val();
    }

    setPeopleFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#people-found-count').text("Nobody Found"); break;
            case 1: $('#people-found-count').text("1 Person Found"); break;
            default: $('#people-found-count').text(count + " People Found");
        }
    }

    createEmailList(matchingUsers: AppUserExtended[]): void {
        this.visibleUserEmails = matchingUsers.map((user: AppUserExtended) => user.AppUser.Email).join("; ");
    }


    resetFilters(): void {

        this.affiliationDropdownIds.forEach((dropdownId: string) => {
            //$(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('deselectAll');
            $(dropdownId).selectpicker('refresh');
        });

        this.groupDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('deselectAll');
            $(dropdownId).selectpicker('refresh');
        });

        this.expertiseDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('deselectAll');
            $(dropdownId).selectpicker('refresh');
        });

        this.dataTable.search('').draw();
        this.updateTable(this.users);
    }


    setOtherTooltipSize(): void {
        const tooltips: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('othertooltiptext') as HTMLCollectionOf<HTMLElement>;
        for (let i = 0; i < tooltips.length; i++) {
            if (tooltips[i].offsetWidth >= 320) {
                tooltips[i].style.whiteSpace = 'normal';
                tooltips[i].style.width = '320px';
            } else {
                tooltips[i].style.whiteSpace = 'nowrap';
                tooltips[i].style.width = '';
            }
        }
    }

    toggleExpertiseSidebar(): void {
        const table = document.getElementById('table-container');
        //const arrow = document.getElementById('arrow');
        //const button = document.getElementById('collapse-button');
        if (!this.sideBarRemoved) {
            this.sideBarRemoved = true;
            table.style.marginLeft = 'auto';
            $('#expertise-sidebar').fadeOut(300, () => {
                table.classList.remove('col-lg-9', 'col-xl-10');
            });
            
            setTimeout(() => {
                this.dataTable.columns.adjust();
                //arrow.classList.remove('fa-arrow-left');
                //arrow.classList.add('fa-arrow-right');
                $("#collapse-button").text("Show Filters");
            }, 600);
        }
        else {
            this.sideBarRemoved = false;
            table.classList.add('col-lg-9', 'col-xl-10');
            this.expertiseSidebar.style.position = 'absolute';
            this.expertiseSidebar.style.maxWidth = '23.7%';
            
            $('#expertise-sidebar').fadeIn(600, () => {
                this.expertiseSidebar.style.position = '';
                this.expertiseSidebar.style.maxWidth = '';
                this.dataTable.columns.adjust();
                //arrow.classList.remove('fa-arrow-right');
                //arrow.classList.add('fa-arrow-left');
                $("#collapse-button").text("Hide Filters");
            });
        }
    }

    updateMenuPosition(e: Event) {
        // set current selected row
        let targetElement = <JQuery<HTMLElement>>$(e.currentTarget);

        // empty any existing menus (menus are moved to this div to avoid overflow issues with table)
        $("#detail-menu-container").empty();

        let dropdownMenu = targetElement.siblings('.revampp-dropdown-menu');
        let dropdownContainer = targetElement.parent();

        let userId = targetElement.data("id");

        // Check is the dropdown menu has been moved to the new #detail-menu-container 
        if (dropdownMenu.length <= 0) {
            // if the menu has already been moved, remove existing dropdwon relationship, and create a new one with new menu options
            targetElement.dropdown('dispose');
            dropdownContainer.append(`
                <div class="dropdown-menu revampp-dropdown-menu ml-2">
                    ${this.getMenuContent(userId)}
                </div>
            `)
            targetElement.dropdown();
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find('.revampp-dropdown-menu');
                $("#detail-menu-container").append(<JQuery<HTMLElement>>$(updatedDropdownMenu))
            });
        }
        else {
            // if the menu has not already been moved (first click), just add the correct menu options.
            dropdownMenu.html(`
                ${this.getMenuContent(userId)}
            `)
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find(".revampp-dropdown-menu");
                $("#detail-menu-container").append(<JQuery<HTMLElement>>$(updatedDropdownMenu));
            });
        }
    }

    getMenuContent(userId: string): string {

        let menuOptions = "";
        let foundUser: AppUserExtended = this.users.find(userExtended => userExtended.AppUser.Id.toString() == userId);
        if (!foundUser) {
            return menuOptions;
        }
        let user = foundUser.AppUser;
        menuOptions += `<div class="font-weight-bold font-size14 px-4 py-1"> ${user.FirstName} ${user.LastName}</div>`
        menuOptions += `<a class="dropdown-item" href="mailto:${user.Email}"><i class="fa-solid fa-envelope blue-icon"></i> <span class="pl-2">Email</span></a>`
        if (user.OrcidLink) {
            menuOptions += `<a class="dropdown-item" target="_blank" href="${user.OrcidLink}"><i class="fa-brands fa-orcid blue-icon"></i> <span class="pl-2">ORCID</span></a>`
        }
        if (user.LinkedinLink) {
            menuOptions += `<a class="dropdown-item" target="_blank" href="${user.LinkedinLink}"><i class="fa-brands fa-linkedin blue-icon"></i> <span class="pl-2">LinkedIn</span></a>`
        }
        if (user.BioLink) {
            menuOptions += `<a class="dropdown-item" target="_blank" href="${user.BioLink}"><i class="fas fa-external-link-alt blue-icon"></i> <span class="pl-2">External Bio</span></a>`
        }

        return menuOptions;
    }
}